var _path, _g, _path2, _path3, _path4, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerateRatecon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01267 5.2645C9.71177 4.55659 10.6653 4.15814 11.6602 4.15814L28.3398 4.15814C29.3347 4.15814 30.2882 4.55659 30.9873 5.2645L40 14.3907V23.2279L0 23.2279L0 14.3907L9.01267 5.2645Z",
    fill: "#D1D5DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35151_34454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.72119 7.41357C3.72119 6.89982 4.13767 6.48334 4.65142 6.48334L35.3491 6.48334C35.8629 6.48334 36.2793 6.89982 36.2793 7.41357V25.5531L3.72119 25.5531L3.72119 7.41357Z",
    fill: "#F9FAFB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30225 11.1349L30.6976 11.1349V12.5302L9.30225 12.5302V11.1349Z",
    fill: "#E5E7EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30225 14.3907L23.2557 14.3907V15.7861L9.30225 15.7861V14.3907Z",
    fill: "#E5E7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.290698 14.6814L10.3148 14.6814C11.6352 14.6814 12.7056 15.7518 12.7056 17.0722C12.7056 18.7137 14.0362 20.0444 15.6777 20.0444H24.3223C25.9638 20.0444 27.2944 18.7137 27.2944 17.0722C27.2944 15.7518 28.3648 14.6814 29.6852 14.6814L39.7093 14.6814V35.321C39.7093 37.2154 38.1735 38.7512 36.2791 38.7512L3.72093 38.7512C1.82647 38.7512 0.290698 37.2154 0.290698 35.321L0.290698 14.6814Z",
    fill: "white",
    stroke: "#D1D5DB",
    strokeWidth: 0.581395
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.1172,
    y: 30.6698,
    width: 11.1628,
    height: 1.39535,
    fill: "#D1D5DB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.1172,
    y: 33.9255,
    width: 7.44186,
    height: 1.39535,
    fill: "#D1D5DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35151_34454",
    x: 0.000261307,
    y: 0.901942,
    width: 40,
    height: 26.5116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.86047
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86047
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35151_34454"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35151_34454",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateRatecon);
export default __webpack_public_path__ + "static/media/generate-ratecon.94ec56a3.svg";
export { ForwardRef as ReactComponent };